module.exports = __webpack_public_path__ + "img/no-image.a63ffe19.png";